import { motion, AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import { Armchair, Palette, Ruler, Tag } from "lucide-react";
import { trackProductView } from "../utils/analytics";
import { getDisplayColor, getDisplayPrice } from "../utils/productDisplay";
import { getOptimizedImageUrl } from "../utils/imageUrl";

export default function ProductModal({ product, onClose }) {
  useEffect(() => {
    if (!product) return;
    trackProductView(product, { item_list_name: "featured_products" });
  }, [product]);

  return (
    <AnimatePresence>
      {product && (
        <motion.div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl max-w-lg w-full p-6 shadow-lg overflow-y-auto max-h-[90vh]"
          >
            <img
              src={getOptimizedImageUrl(product.image, { width: 800 })}
              alt={product.name}
              decoding="async"
              className="w-full h-64 object-cover rounded-lg mb-4"
            />
            <div className="grid grid-cols-3 gap-2 mb-4">
              {product.gallery?.map((img, i) => (
                <img
                  key={i}
                  src={getOptimizedImageUrl(img, { width: 240 })}
                  alt={`Gallery ${i}`}
                  loading="lazy"
                  decoding="async"
                  className="h-24 w-full object-cover rounded-lg"
                />
              ))}
            </div>
            <h2 className="text-2xl font-bold mb-2">{product.name}</h2>
            <p className="text-red-600 font-semibold mb-2">{getDisplayPrice(product.price)}</p>
            <p className="text-gray-700 mb-3 whitespace-pre-line">
              {product.description}
            </p>

            <ul className="text-sm text-gray-600 mb-4">
              <li className="flex items-start gap-2"><Ruler className="mt-0.5 h-4 w-4" /> {product.size}</li>
              <li className="mt-2 flex items-start gap-2"><Palette className="mt-0.5 h-4 w-4" /> {getDisplayColor()}</li>
              <li className="mt-2 flex items-start gap-2"><Armchair className="mt-0.5 h-4 w-4" /> {product.material}</li>
              <li className="mt-2 flex items-start gap-2"><Tag className="mt-0.5 h-4 w-4" /> {product.type}</li>
            </ul>
            <button
              onClick={onClose}
              className="bg-[var(--color-primary)] text-white px-4 py-2 rounded-lg hover:bg-[#805b42] w-full"
            >
              Đóng
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
